import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  d: "M22 11V3h-7v3H9V3H2v8h7V8h2v10h4v3h7v-8h-7v3h-2V8h2v3h7zM7 9H4V5h3v4zm10 6h3v4h-3v-4zm0-10h3v4h-3V5z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7 5v4H4V5h3M20 5v4h-3V5h3M20 15v4h-3v-4h3",
  opacity: ".3"
})), 'AccountTreeTwoTone');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/AccountTreeTwoTone.js
// module id = 1846
// module chunks = 2